




















































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import Link from '@/components/Link.vue'

export default defineComponent({
  name: 'NewButton',
  components: { Link },
  props: {
    as: {
      type: String as PropType<'button' | 'Link' | 'a'>,
      default: 'button',
    },
    url: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    disabledState: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String as PropType<
        | 'primary'
        | 'outline'
        | 'secondary'
        | 'secondary-new'
        | 'ghost'
        | 'tertiary'
      >,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'button',
    },
    size: {
      type: String as PropType<'small' | 'normal'>,
      default: 'normal',
    },
    active: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    rounding: {
      type: String as PropType<'full' | 'normal' | 'total'>,
      default: 'normal',
    },
    icon: {
      type: String,
      default: '',
    },
    capture: {
      type: Boolean,
      default: true,
    },
    stopPropagation: {
      type: Boolean,
      default: true,
    },
    disableFocusStyles: {
      type: Boolean,
      default: false,
    },
    testId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const componentProps = computed(() => {
      switch (props.as) {
        case 'a':
          return { href: props.url }
        case 'Link':
          return { url: props.url }
        default:
          return {}
      }
    })
    return {
      componentProps,
    }
  },
  mounted() {
    this.$el.addEventListener('click', this.handler, this.capture)
  },
  beforeDestroy() {
    this.$el.removeEventListener('click', this.handler, this.capture)
  },
  methods: {
    handler(e) {
      if (this.stopPropagation) {
        e.stopPropagation()
      }
      this.$emit('click', e)
    },
  },
})
